const EMPTY = Symbol('EMPTY')
const READY = Symbol('READY')

export const sectionStatus = {
  EMPTY,
  READY,
}

export default sectionStatus
